import React, { useState, useEffect } from 'react';

export default function CookieConsent({ t, manageHref = '/cookie-settings', onManage }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  const handleManage = (e) => {
    if (onManage) {
      e.preventDefault();
      onManage(); // e.g. open your cookie settings modal
    }
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        background: '#333',
        color: 'white',
        padding: '1rem',
        textAlign: 'center',
        zIndex: 1000,
      }}
      role="dialog"
      aria-live="polite"
    >
      <p style={{ margin: 0 }}>
        {t('consent.message')}
      </p>

      <div style={{ marginTop: '0.75rem', display: 'inline-flex', gap: '0.5rem' }}>
        <a
          href={manageHref}
          onClick={handleManage}
          style={{
            background: 'transparent',
            color: '#fff',
            border: '1px solid #fff',
            borderRadius: '4px',
            padding: '0.5rem 1rem',
            textDecoration: 'none',
          }}
        >
          {t('consent.manage')}
        </a>

        <button
          onClick={acceptCookies}
          style={{
            marginLeft: '0.25rem',
            padding: '0.5rem 1rem',
            background: '#00b5d8',
            color: '#fff',
            border: '1px solid #00b5d8',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          {t('consent.accept')}
        </button>
      </div>
    </div>
  );
}
